import { render, staticRenderFns } from "./ProductComponentsWrapper.vue?vue&type=template&id=d9a72110"
import script from "./ProductComponentsWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductComponentsWrapper.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports